import React from 'react'
import { ActionIcon } from '@mantine/core'
import { IconBrandFacebook } from '@tabler/icons-react'

/**
 * Renders the Facebook link.
 * @param {string} url The Facebook URL.
 * @param {string} color The text color for the button.
 * @returns {JSX.Element}
 */
function FacebookIcon ({ url, color }) {
  return (
    <ActionIcon
      variant='filled'
      color={color}
      aria-label='Facebook'
      size='sm'
      component='a'
      href={url}
      target='_blank'
      autoContrast
    >
      <IconBrandFacebook stroke={2} aria-label='Follow on Facebook' />
    </ActionIcon>
  )
}

export default React.memo(FacebookIcon)
